import { CellValue } from "@material-ui/data-grid";
import React, { useRef } from "react";
import { MdContentCopy } from "react-icons/md";
import styled from "styled-components";

interface ClipboardFieldProps {
  value: CellValue;
}

const ClipboardField: React.FC<ClipboardFieldProps> = ({ value }) => {
  const urlRef = useRef<HTMLInputElement>(null);
  const onClick = (event: React.MouseEvent<SVGElement, MouseEvent>) => {
    event.preventDefault();
    if (urlRef) {
      urlRef.current!.select();
      document.execCommand("copy");
    }
  };
  return (
    <Row>
      <MdContentCopy
        style={{ width: 32, height: 32, marginRight: 5, cursor: "pointer" }}
        onClick={onClick}
      />
      <URL type="text" ref={urlRef} value={value?.toString()} />
    </Row>
  );
};

export default ClipboardField;

const URL = styled.input`
  color: gray;
  overflow: hidden;
  width: 90%;
`;
const Row = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
